import { useOrganizationDetailsStore } from '@libs/store/settings';
import React, { useEffect } from 'react';

export const TabTitleChanger: React.FC = () => {
  const { load, data, initialized } = useOrganizationDetailsStore();

  useEffect(() => {
    if (!initialized) {
      load();
    }
  }, [load, initialized]);

  useEffect(() => {
    let title = document.querySelector('title');
    if (!title) {
      title = document.createElement('title');
      document.getElementsByTagName('head')[0].appendChild(title);
    }
    if (data?.name) {
      title.innerText = data?.name;
    }
  }, [data]);

  return <></>;
};
